// extracted by mini-css-extract-plugin
export default {"img":"VendorComplete_img__h8E5A","button":"VendorComplete_button__YuyiP"};